import {
  Box,
  Divider,
  Link,
  Slider,
  Tab,
  Tabs,
  Typography,
} from "@mui/material";
import PrimaryIcon from "Components/Common/PrimaryIcon";
import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { ReactComponent as CashReward } from "Assets/Icons/Referral/CashReward.svg";
import { ReactComponent as AmazonIcon } from "Assets/Icons/Referral/AmazonIcon.svg";
import { ReactComponent as CodedCoin } from "Assets/Icons/Referral/CodedCoin.svg";
import { ReactComponent as FlipkartIcon } from "Assets/Icons/Referral/FlipkartIcon.svg";
import { ReactComponent as GiftCard } from "Assets/Icons/Referral/GiftCard.svg";
import { ReactComponent as MyntraIcon } from "Assets/Icons/Referral/MyntraIcon.svg";
import { ReactComponent as PlusIcon } from "Assets/Icons/Settings/PlusIcon.svg";

const RewardsCalculatorSection = ({ from, currentTab, setCurrentTab }) => {
  const [referralCount, setReferralCount] = useState(2);
  const [referralReward, setReferralReward] = useState({});

  const isDialog = from == "dialog";
  const designParams = {
    boxPadding: isDialog ? "16px" : "30px",
    cashReward: {
      width: isDialog ? "60px" : "120px",
    },
    codedCoin: {
      width: isDialog ? "60px" : "80px",
    },
    giftBoxPadding: isDialog ? "8px" : "16px",
    giftCard: {
      width: isDialog ? "65px" : "115px",
    },
    myntraIcon: {
      width: isDialog ? "22px" : "45px",
      height: isDialog ? "16px" : "32px",
    },
    amazonIcon: {
      width: isDialog ? "16px" : "32px",
      height: isDialog ? "16px" : "32px",
    },
    flipkartIcon: {
      width: isDialog ? "17px" : "35px",
      height: isDialog ? "17px" : "32px",
    },
  };

  const { ReferralReward, Translation } = useSelector((state) => ({
    ReferralReward: state.ReferralReward.referralReward,
    Translation: state.Translation.translation?.Referral || {},
  }));

  const handleTabChange = (value) => {
    if (Array.isArray(ReferralReward)) {
      setCurrentTab(value);
      setReferralReward(ReferralReward[value])
    }
  }

  useEffect(() => {
    if (Array.isArray(ReferralReward)) {
      setReferralReward(ReferralReward[currentTab])
    }

  }, [ReferralReward])
  

  return (
    <>
      <Box>
        <Typography mb="8px">
          {Translation?.ReferFriendWorthyReward}
        </Typography>
        <Tabs
          type="filled"
          value={currentTab}
          TabIndicatorProps={{ hidden: true }}
          sx={{ marginBottom: "0px" }}
          onChange={(e, value) => handleTabChange(value)}
        >
          { Array.isArray(ReferralReward) && ReferralReward.map((category, index) => {
            return <Tab value={index} label={category?.Name} />
          })
          }
          {/* <Tab value={"pre"} label={"Pre-Coded Entrance Tes"} />
          <Tab value={"post"} label={"Post-Coded Entrance Tes"} /> */}
        </Tabs>
      </Box>
      <Typography color="secondary.light">
        {Translation?.ReferralRewardForlearners}{" "}
        <Link fontWeight={500} href="#" underline="none">
          {" "}
          {Translation.Before}{" "}
        </Link>{" "}
        {Translation?.CodedPlusEntranceTest}
      </Typography>
      <Box
        sx={(theme) => ({
          background: theme.palette.background.default,
          borderRadius: "8px",
          padding: "8px",
        })}
      >
        <Box
          display={"flex"}
          alignItems={"center"}
          justifyContent={"space-between"}
        >
          <Typography variant="subtitle" fontWeight={500}>
            {Translation?.HowManyFriendRefer}
          </Typography>
          <Typography>{(referralCount + 1)} {Translation?.Friends}</Typography>
        </Box>
        <Box mt="10px">
          <Slider
            value={referralCount}
            onChange={(_, value) => setReferralCount(value)}
            valueLabelFormat={(value) => `${value + 1} `}
            valueLabelDisplay="auto"
            sx={(theme) => ({
              "& .MuiSlider-markLabel[data-index='0']": {
                transform: "unset",
              },
              "& .MuiSlider-markLabel[data-index='7']": {
                transform: "translateX(-100%)",
              },
              "& .MuiSlider-rail": {
                background: theme.palette.white.main,
                opacity: 1,
              },
            })}
            max={7}
            marks={[
              { value: 0, label: `1 ${Translation?.Referral}` },
              { value: 1, label: `2 ${Translation?.Referral}` },
              { value: 2, label: `3 ${Translation?.Referral}` },
              { value: 3, label: `4 ${Translation?.Referral}` },
              { value: 4, label: `5 ${Translation?.Referral}` },
              { value: 5, label: `6 ${Translation?.Referral}` },
              { value: 6, label: `7 ${Translation?.Referral}` },
              { value: 7, label: `8 ${Translation?.Referral}` },
            ]}
          />
        </Box>
      </Box>
      <Box display={"flex"} alignItems={"center"} gap={"16px"}>
        <Box
          sx={(theme) => ({
            width: "100%",
            display: "flex",
            flexDirection: "column",
            gap: "16px",
            "&>div": {
              border: `1px solid ${theme.palette.border.blue}`,
              borderRadius: "16px",
              padding: designParams?.boxPadding,
            },
          })}
        >
          <Box
            display={"flex"}
            alignItems={"center"}
            justifyContent={"space-between"}
          >
            <Box display={"flex"} flexDirection={"column"} gap={"8px"}>
              <Typography variant="subtitle" fontWeight={500}>
                {Translation?.InCashReward}
              </Typography>
              <Typography variant="subtitle" fontWeight={500}>
                {referralReward?.CurrencyCode} {referralReward?.Cash * (referralCount + 1)}
              </Typography>
            </Box>
            <PrimaryIcon
              icon={CashReward}
              fill={false}
              width={designParams?.cashReward?.width}
              height="100%"
            />
          </Box>
          <Box
            display={"flex"}
            alignItems={"center"}
            justifyContent={"space-between"}
          >
            <Box display={"flex"} flexDirection={"column"} gap={"8px"}>
              <Typography variant="subtitle" fontWeight={500}>
                {Translation?.CodedCoins}
              </Typography>
              <Typography variant="subtitle" fontWeight={500}>
                {referralReward?.Coin * (referralCount + 1)}
              </Typography>
            </Box>
            <PrimaryIcon
              icon={CodedCoin}
              fill={false}
              width={designParams?.codedCoin?.width}
              height="100%"
            />
          </Box>
        </Box>
        <Divider
          sx={(theme) => ({
            display: "flex",
            "& .MuiDivider-wrapper": {
              padding: "0px",
            },
            "& svg": {
              border: `1px solid ${theme.palette.border.grey}`,
              padding: "5px",
              borderRadius: "50%",
            },
          })}
          flexItem
          orientation="vertical"
        >
          <PrimaryIcon icon={PlusIcon} color="border" variant="grey" />
        </Divider>
        <Box
          sx={(theme) => ({
            width: "100%",
            display: "flex",
            flexDirection: "column",
            border: `1px solid ${theme.palette.border.blue}`,
            borderRadius: "16px",
            padding: designParams?.giftBoxPadding,
            height: "100%",
          })}
        >
          <Box
            sx={(theme) => ({
              padding: designParams?.giftBoxPadding,
              borderRadius: "8px",
              background: theme.palette.background.default,
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              width: "--webkit-fill-available",
            })}
          >
            <PrimaryIcon
              icon={GiftCard}
              fill={false}
              width={designParams?.giftCard?.width}
              height="100%"
            />
            <Box
              display={"flex"}
              alignItems={"center"}
              flexDirection={"column"}
              gap={"16px"}
            >
              <Typography fontWeight={500} fontSize={"28px"}>
                {Translation?.GiftCard}
              </Typography>
              <Box display={"flex"} alignItems={"center"} gap="24px">
                <PrimaryIcon
                  icon={MyntraIcon}
                  fill={false}
                  width={designParams?.myntraIcon?.width}
                  height={designParams?.myntraIcon?.width}
                />
                <PrimaryIcon
                  icon={AmazonIcon}
                  fill={false}
                  width={designParams?.amazonIcon?.width}
                  height={designParams?.amazonIcon?.width}
                />
                <PrimaryIcon
                  icon={FlipkartIcon}
                  fill={false}
                  width={designParams?.flipkartIcon?.width}
                  height={designParams?.flipkartIcon?.width}
                />
              </Box>
            </Box>
          </Box>
          <Box
            padding={"30px 0px"}
            display={"flex"}
            justifyContent={"space-between"}
          >
            <Typography variant="subtitle" fontWeight={500}>
              {Translation?.EVouchers} {Translation?.Worth}
            </Typography>
            <Typography variant="subtitle" fontWeight={500}>
              {referralReward?.CurrencyCode} {referralReward?.Voucher * (referralCount + 1)}
            </Typography>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default RewardsCalculatorSection;
